import './AccordionCombo.css';
import React from 'react';
import { useSitecoreContext } from '../../utils/SitecoreContextReactContext';
import { get, injectImageResolution } from '../../utils';
import ComponentsWrapper from '../atoms/ComponentsWrapper';
import { AccordionItem } from './AccordionItem';
import StatisticsCard from './StatisticsCard';
import CarouselProvider from '../atoms/CarouselProvider/CarouselProvider';
import LazyPicture from '../atoms/LazyPicture';
import { RichText, Text } from '@sitecore-jss/sitecore-jss-react';
const BASE_URL = process.env.REACT_APP_MEDIA_HOST ? process.env.REACT_APP_MEDIA_HOST : '';
const AccordionCombo = props => {
  const sitecoreContext = useSitecoreContext();
  const rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  const description = get(props, "fields.data.item.description.jss.value", "");
  const accordionDescription = get(props, "fields.data.item.accordionDescription.jss.value", "");
  const isTwoColumns = get(props, "params.variant") !== "Horizontal";
  const items = get(props, "fields.data.item.children", []);
  const images = get(props, "fields.data.item.images.targetItems", []);
  const containerTitle = get(props, "fields.data.item.title.jss.value", "");
  const isDetSite = get(props.params, 'RenderingStyle') === 'DDA';
  let statistics = get(props, "fields.data.item.statistics.targetItems", []);
  if (images.length && isTwoColumns) {
    statistics = statistics.slice(0, 2);
  } else if (!isTwoColumns) {
    statistics = statistics.slice(0, 4);
  } else {
    statistics = statistics.slice(0, 6);
  }
  const [activeItemsIds, setActiveItemsIds] = React.useState([]);
  const handleItemChange = (id, isActive) => {
    if (isActive) {
      setActiveItemsIds(activeItemsIds.filter(activeId => activeId !== id));
    } else {
      setActiveItemsIds([...activeItemsIds, id]);
    }
  };
  const rendetItems = () => {
    return images.map(image => /*#__PURE__*/React.createElement(LazyPicture, {
      className: "accordion-combo__image-from-carousel",
      hover: true
    }, /*#__PURE__*/React.createElement("source", {
      media: "(min-width: 768px)",
      src: injectImageResolution(`${BASE_URL || ""}${image.url}`, 700, 525)
    }), /*#__PURE__*/React.createElement("img", {
      src: injectImageResolution(`${BASE_URL || ""}${image.url}`, 700, 525),
      alt: image.alt.jss.value,
      draggable: false
    })));
  };
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    rtl: rtl,
    isDetSite: isDetSite,
    anchorUrl: props.params["Anchor Url Parameter"]
  }, (containerTitle || accordionDescription) && isTwoColumns && /*#__PURE__*/React.createElement("div", {
    className: "titleDescriptionWrapper"
  }, containerTitle ? /*#__PURE__*/React.createElement(Text, {
    className: "accordion-combo__title",
    tag: "h3",
    field: {
      value: containerTitle
    }
  }) : null, accordionDescription ? /*#__PURE__*/React.createElement(RichText, {
    className: "accordionDescription",
    tag: "div",
    field: {
      value: accordionDescription
    }
  }) : null), /*#__PURE__*/React.createElement("div", {
    className: `accordion-combo ${isTwoColumns ? "accordion-combo--two-columns" : "accordion-combo--horizontal"}`
  }, /*#__PURE__*/React.createElement("div", {
    className: "accordion-combo__accordion-section-wrapper"
  }, (containerTitle || accordionDescription) && !isTwoColumns && /*#__PURE__*/React.createElement("div", {
    className: "titleDescriptionWrapper"
  }, containerTitle ? /*#__PURE__*/React.createElement(Text, {
    className: "accordion-combo__title",
    tag: "h3",
    field: {
      value: containerTitle
    }
  }) : null, accordionDescription ? /*#__PURE__*/React.createElement(RichText, {
    className: "accordionDescription",
    tag: "div",
    field: {
      value: accordionDescription
    }
  }) : null), description && isTwoColumns && /*#__PURE__*/React.createElement(RichText, {
    className: "accordion-combo__description",
    tag: "div",
    field: {
      value: description
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: "accordion-combo__statistic-section accordion-combo__section"
  }, /*#__PURE__*/React.createElement("div", {
    className: "accordion-combo__statistic-section-wrapper"
  }, isTwoColumns && images.length === 1 && images[0].url && /*#__PURE__*/React.createElement(LazyPicture, {
    className: "accordion-combo__img",
    hover: true
  }, /*#__PURE__*/React.createElement("source", {
    media: "(min-width: 768px)",
    srcSet: injectImageResolution(`${BASE_URL || ""}${images[0].url}`, 710, 394)
  }), /*#__PURE__*/React.createElement("img", {
    src: injectImageResolution(`${BASE_URL || ""}${images[0].url}`, 710, 394),
    alt: images[0].alt.jss.value
  })), isTwoColumns && images.length > 1 && /*#__PURE__*/React.createElement(CarouselProvider, null, _ref => {
    let {
      renderCarousel,
      renderPreviousButton,
      renderNextButton,
      renderDots
    } = _ref;
    return /*#__PURE__*/React.createElement("div", {
      className: "accordion-combo__picture-carousel"
    }, /*#__PURE__*/React.createElement("div", {
      className: "accordion-combo__carousel-wrapper"
    }, /*#__PURE__*/React.createElement("div", {
      className: "accordion-combo__carousel-btn accordion-combo__carousel-btn-prev"
    }, renderPreviousButton(() => {}, false, false, null, isDetSite)), renderCarousel(rendetItems(), {
      responsive: {
        desktop: {
          breakpoint: {
            max: 10000,
            min: 0
          },
          items: 1
        }
      }
    }), /*#__PURE__*/React.createElement("div", {
      className: "accordion-combo__carousel-btn accordion-combo__carousel-btn-next"
    }, renderNextButton(() => {}, false, false, null, isDetSite))), renderDots(() => {}, [], isDetSite));
  }), statistics.length > 1 && /*#__PURE__*/React.createElement("div", {
    className: "accordion-combo__statistics-cards"
  }, statistics.map(el => get(el, "intro.jss") && get(el, "statNumber.jss") && /*#__PURE__*/React.createElement(StatisticsCard, {
    key: el.id,
    description: el.intro.jss,
    value: el.statNumber.jss,
    isDetSite: isDetSite
  }))))), description && !isTwoColumns && /*#__PURE__*/React.createElement(RichText, {
    className: "accordion-combo__description",
    tag: "div",
    field: {
      value: description
    }
  }), items.length > 0 && /*#__PURE__*/React.createElement("div", {
    className: "accordion-combo__accordion-section accordion-combo__section"
  }, /*#__PURE__*/React.createElement("div", {
    className: "accordion-combo__accordion-section-wrapper"
  }, /*#__PURE__*/React.createElement("div", {
    className: "accordion-combo__list-wrapper"
  }, items.map(item => {
    const isActive = activeItemsIds.includes(item.id);
    return /*#__PURE__*/React.createElement(AccordionItem, {
      key: item.id,
      isActive: isActive,
      onChange: () => handleItemChange(item.id, isActive),
      item: item,
      isDetSite: isDetSite,
      isTwoColumns: isTwoColumns,
      pageEditing: !!sitecoreContext.pageEditing
    });
  }))))));
};
export default AccordionCombo;
const StyledWrapper = _ref2 => {
  let {
    children,
    rtl,
    isDetSite,
    anchorUrl
  } = _ref2;
  const commonStyles = isDetSite ? "ccmlgc2" : "c1iqwb7z";
  const ltrStyles = isDetSite ? "l5w5c51" : "l1slo4n4";
  const rtlStyles = isDetSite ? "ravjwoc" : "rusf5k6";
  return /*#__PURE__*/React.createElement(ComponentsWrapper, {
    className: `${commonStyles} ${rtl ? rtlStyles : ltrStyles}`,
    anchorUrlParameter: anchorUrl
  }, children);
};